import { AnyAction } from 'redux';

// 1. Define Interfaces
export interface DocumentItem {
    fileName: string;
    isUploaded: boolean;
    isLoading: boolean;
    isDeleted: boolean;
}

export interface DocumentState {
    documents: DocumentItem[];
    // Adding optional properties used in SUCCESS and DELETE cases
    // to match your original logic's flat state updates
    fileName?: string;
    isUploaded?: boolean;
    isLoading?: boolean;
    isDeleted?: boolean;
}

const initState: DocumentState = {
    documents: [],
};

// 2. Reducer
export default function reducer(
    state: DocumentState = initState,
    action: AnyAction = { type: '' },
): DocumentState {
    switch (action.type) {
        case 'DOCUMENT_START_UPLOAD_PROCESS':
            return {
                ...state,
                documents: [...state.documents, {
                    fileName: action.payload,
                    isUploaded: false,
                    isLoading: true,
                    isDeleted: false,
                }],
            };
        case 'DOCUMENT_UPLOAD_SUCCESS':
            return {
                ...state,
                fileName: action.payload,
                isUploaded: true,
                isLoading: false,
                isDeleted: false,
            };
        case 'DELETE_DOCUMET':
            return {
                ...state,
                fileName: action.payload,
                isUploaded: true,
                isLoading: true,
                isDeleted: true,
            };
        case 'CLEAR_DOCUMETS':
            return {
                documents: [],
            };

        default:
            return state;
    }
}
